import { createContext } from "react";

const BseContext = createContext();

export default BseContext;
